import { createAction, handleActions } from 'redux-actions'

const setActiveTab = createAction('SCREENS/SUBBIES/SET_ACTIVE_TAB')
const resetActiveTab = createAction('SCREENS/SUBBIES/RESET_ACTIVE_TAB')

const defaultState = 'subcontractors'

const reducer = handleActions(
  {
    [setActiveTab]: (state, { payload }) => payload,
    [resetActiveTab]: () => defaultState,
  },
  defaultState,
)

export { setActiveTab, resetActiveTab, reducer }
